// PaymentPage.js — starts Stripe-hosted Checkout (no in-app card Elements)
import React from 'react'
import CheckoutForm from './CheckoutForm'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom/cjs/react-router-dom'

const PaymentPage = () => {
  const venueId = useSelector(state => state.venue.venue._id)
  const state = useLocation().state
  const { priceId, discountId, price } = state || {}
  return (
    <CheckoutForm
      venueId={venueId}
      priceId={priceId}
      discountId={discountId}
      price={price}
    />
  )
}

export default PaymentPage
